/* eslint-disable import/prefer-default-export */
import { call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import * as Api from "../../api";
import * as actions from "../actions";

export function* markDocumentReadPusterla({ payload }) {
  yield put(actions.setPusterlaReadingLoading(true));

  try {
    const filename = payload;
    yield call(Api.markDocumentRead, {
      document_read: filename,
      pusterla: true,
    });
    yield put(actions.setPusterlaReadingLoading(false));
  } catch (error) {
    yield put(actions.addError("Reading List Pusterla", error));
    yield put(actions.setPusterlaReadingLoading(false));
  }
}

export function* postPusterlaFormsSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.postPusterlaForms, formName, formContent);
  } catch (error) {
    yield put(actions.addError("post-pusterla-form", error));
  }
}

export function* submitPusterlaFormsSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    const score = yield call(Api.submitPusterlaForms, formName, formContent);
    yield put({ type: types.POST_PUSTERLA_ASSESSMENT_SCORE, payload: score }); // save for the retry of tests
  } catch (error) {
    yield put(actions.addError("submit-pusterla-form", error));
  }
}
